import { UserModel } from '$tablet-app/src/app/auth/UserModel';
import { User } from '@akin-home/amplify';
import React, { FC } from 'react';
import styled from 'styled-components/native';
import CheckBoxCircle from '../CheckBoxCircle';
import PopUpMenu from '../PopUpMenu';
import { ProfileIcon } from '../ProfileIcon/ProfileIcon';
import Spacer from '../Spacer';
import Text from '../Text';

interface Props {
  users?: User[];

  selected_ids?: string[];

  onSelect?: (id: string) => void;

  /** Anchor for user multiselect */
  anchor: (params: { showPopUp: () => void }) => React.ReactNode;
}

const empty_users: UserModel[] = [];

const UserMultiselectDropdown: FC<Props> = (props) => {
  const { users = empty_users, selected_ids, onSelect, anchor } = props;

  return (
    <PopUpMenu anchor={anchor}>
      {() =>
        users.map((user) => (
          <UserMultiSelectItem
            key={user.id}
            user={user}
            selected={selected_ids?.includes(user.id)}
            onSelect={onSelect}
          />
        ))
      }
    </PopUpMenu>
  );
};

const UserMultiSelectItem: FC<{
  user: UserModel;
  selected?: boolean;
  onSelect?: (id: string) => void;
}> = ({ user, selected, onSelect }) => {
  const onPress = () => onSelect?.(user.id);

  return (
    <ItemContainer onPress={onPress}>
      <ProfileIcon profile={user} />
      <Spacer width="8px" />
      <UserName>{user.name}</UserName>
      <Spacer width="16px" />
      <CheckBoxCircle checked={selected} />
    </ItemContainer>
  );
};

const ItemContainer = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;

  height: 54px;
  padding: 14px;
`;

const UserName = styled(Text)`
  flex: 1 0 200px;
  min-width: 200px;
`;

export default UserMultiselectDropdown;
